// ==============================|| OVERRIDES - TOOLTIP ||============================== //

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.primary.greyPrimaryTransparency,
          color: theme.palette.primary.white,
          borderRadius: theme.shape.customBorderRadius[1],
          fontSize: theme.typography.customFontSize[1],
        },
        arrow: {
          color: theme.palette.primary.greyPrimaryTransparency,
        },
      },
    },
  };
}

